import { downloadImageValidation, imageValidationApi, masterReportsApi, modeList, userStatusApi } from "api";
import axios from "axios";

const getNewModel = (model, isStyle) => {
    if (model === "stylemasters") {
        return isStyle ? "stylemasters" : "cad";
    }
    return model;
};


class dashboardClient {
    async userReport() {
        try {
            const userReportResult = await userStatusApi();
            const statsArray = userReportResult.data.data.map(_state => ({
                name: _state._id === 'active' ? "Active" : "Inactive",
                value: _state.count
            }));
            const totalUser = statsArray.reduce((acc, _item) => _item.value + acc, 0);
            return { statsArray, totalUser }
        } catch (error) {
            console.log(error)
            return { error }
        }
    }
    async fetchReports(modelName) {
        try {
            const masterReportResult = await masterReportsApi(modelName);
            const data = masterReportResult.data.data;
            return { data }
        } catch (error) {
            console.log(error)
            return { error }
        }
    }
    async fetchModalList() {
        try {
            const { data } = await modeList({});
            const updatedList = data.data.map((val) => ({
                label: val.model,
                value: val.model,
                modelId: val._id
            }));
            return { updatedList }
        } catch (error) {
            return { error }
        }
    }
    async fetchImageValidation(model, isStyle) {
        try {
            const newmodel = getNewModel(model, isStyle)
            const report = await imageValidationApi(newmodel)
            
            const statsArray = report.data.data.imageExist.map(_state => ({ name: _state._id ? "Available" : "Unavailable", value: _state.count }));
            const totalImage = statsArray.reduce((acc, item) => acc + item.value, 0);

            const cscWiseReport = report.data.data.cscWiseReport.map(_state => ({
                "Available": _state.available,
                "NotAvailable": _state.notAvailable,
                ..._state
            }))
            const folderWiseReport = report.data.data.folderReport.map(_state => ({
                "Available": _state.available,
                "NotAvailable": _state.notAvailable,
                ..._state
            }))
            let currentSatus
            try {
                const { data } = await axios.post(`${process.env.REACT_APP_DAM_IMAGE}/imageValidation/current-status`, { model: newmodel }, { headers: {} })
                currentSatus = data
            } catch (error) {
                console.log(error)
            }
            return {report, currentSatus, folderWiseReport, cscWiseReport, totalImage }
        } catch (error) {
            return { error }
        }
    }


    async downloadImageValidationReport(model, isStyle) {
        try {
            const newmodel = getNewModel(model, isStyle)
            const response = await downloadImageValidation(newmodel);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${model || 'image-validation-report'}.xlsx`);

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            return { error }
        }
    }
    async imageValidationHandle(model, isStyle) {
        try {
            const newmodel = getNewModel(model, isStyle)
            const { data } = await axios.post(`${process.env.REACT_APP_DAM_IMAGE}/imageValidation/generate`, { model: newmodel }, { headers: {} })
            return { data }
        } catch (error) {
            return { error }
        }
    }
}


const dashbaordInstance = new dashboardClient();

export default dashbaordInstance;